export default __webpack_public_path__ + "static/media/LavieSport1.febff1c2.jpg";